<template>

  <div class="mt-0 page page-active-delivery">

    <!-- Page Content -->
    <v-container fluid>
      <transition name="fade-flash" mode="out-in">
        <router-view />
      </transition>
    </v-container>

  </div>

</template>

<script>
export default {
  name: 'ActiveDeliveryRootPage',

  props: {
    routeId: {
      type: String,
      default: null
    }
  },

  computed: {
    // The active route (delivery)
    activeDelivery () {
      return this.$store.getters['sh/data']('activeDelivery')
    }
  },

  async beforeMount () {
    // Ensure active delivery is loaded
    this.loadActiveDelivery()
  },

  beforeDestroy () {
    // Clear active delivery
    this.$store.dispatch('sh/clearData', 'activeDelivery')
  },

  methods: {
    // Loads the active Route into the store (with orders, vehicle, driver)
    async loadActiveDelivery () {
      await this.$store.dispatch('sh/loadData', {
        resource: 'activeDelivery',
        id: this.routeId,
        params: { with: 'orders,vehicle,vehicle_lot,driver' },
        force: true
      })

      // Mount location on order (for delivery stepper)
      if (this.activeDelivery.orders && this.activeDelivery.orders.length > 0) {
        for (const order of this.activeDelivery.orders) {
          const shipper = (order.shipper_id)
            ? await this.$store.dispatch('sh/fetchData', { resource: 'shipper', id: order.shipper_id })
            : null
          const receiver = (order.receiver_id)
            ? await this.$store.dispatch('sh/fetchData', { resource: 'receiver', id: order.receiver_id })
            : null

          // Mount on order
          order.shipper = shipper
          order.receiver = receiver
        } // end-for
      }

      // Ensure route is enabled for edit (for delivery stepper)
      const activePage = this.$router.currentRoute.name
      if (activePage === 'delivery-stepper') {
        this.$store.dispatch('sh/setItemToEdit', {
          resource: 'activeDelivery',
          data: this.activeDelivery
        })
      }
    }
  }
}
</script>

<style scoped>
</style>
